import dbGateway from '@/api/dbGateway';

const model = {

  getproductMatrixList(param = {}) {
    return dbGateway.post('/sys/productMatrix/list', param);
  },

  
  saveproductMatrix(param = {}) {
    if (param.id) {
      return dbGateway.post('/sys/productMatrix/modify', param);
    }
    return dbGateway.post('/sys/productMatrix/create', param);
  },

  
  getproductMatrixById(param = {}) {
    return dbGateway.get(`/sys/productMatrix/${param.id}`);
  },

  
  deleteproductMatrixById(param = {}) {
    return dbGateway.post('/sys/productMatrix/remove', param);
  },

  
  syncproductMatrix(param = {}) {
    return dbGateway.post('/sys/productMatrix/syncProductMatrix', param);
  },
 
  moveProduct(param) {
    return dbGateway.post('sys/productMatrix/move', param);
  },
};

export default model;
